import React, { ChangeEvent, useState } from "react"
import { Box, Checkbox, FormControlLabel, Grid, TextField } from "@mui/material"
import { SubmitHandler, useForm } from "react-hook-form"
import { OreveButton } from "components/button/OreveButton.tsx"
import AddIcon from "@mui/icons-material/Add"

export const CardNumberInput = ({ cardNumber }: { cardNumber: string }) => {
    const segments = cardNumber.split(" ")

    const textFields = segments.map((segment, index) => (
        <React.Fragment key={index}>
            <TextField
                variant="outlined"
                size="small"
                margin="normal"
                value={segment}
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "60px",
                    outline: "none",
                    backgroundColor: "grey.100",
                    "& .MuiOutlinedInput-input": {
                        textAlign: "center",
                    },
                    "& .MuiOutlinedInput-root": {
                        pointerEvents: "none",
                    },
                }}
                InputProps={{
                    readOnly: true,
                }}
            />
            {index < segments.length - 1 && <span>&nbsp;</span>}
        </React.Fragment>
    ))

    return <Box sx={{ display: "flex", gap: "5px" }}>{textFields}</Box>
}

type PaymentFormValues = Record<string, unknown>

interface PaymentFormProps {
    onSubmit: SubmitHandler<PaymentFormValues>
    defaultValues: PaymentFormValues
    fields: { name: string; label: string; component: React.ElementType }[]
}

export const PaymentForm = ({
    onSubmit,
    defaultValues,
    fields,
}: PaymentFormProps) => {
    const { register, handleSubmit } = useForm({ defaultValues })
    const [defaultPayment, setDefaultPayment] = useState(true)

    const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
        setDefaultPayment(event.target.checked)
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={2} sx={{ mb: "1rem" }}>
                {fields.map((field, index) => (
                    <Grid size={{xs:6, sm:6}} key={index}>
                        <field.component
                            label={field.label}
                            {...register(field.name, { required: true })}
                        />
                    </Grid>
                ))}
            </Grid>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
                <FormControlLabel
                    sx={{ mb: "1rem" }}
                    control={
                        <Checkbox
                            checked={defaultPayment}
                            onChange={handleCheckboxChange}
                            sx={{
                                color: (theme) => theme.palette.secondary.main,
                                "&.Mui-checked": {
                                    color: (theme) =>
                                        theme.palette.secondary.main,
                                },
                            }}
                        />
                    }
                    label="Définir comme mode de paiement par défaut"
                />
                <OreveButton
                    type="submit"
                    variant={"contained"}
                    color={"primary"}
                    value="Ajouter une carte"
                    icon={AddIcon}
                    loading={false}
                />
            </Box>
        </form>
    )
}
